import { useQuery } from 'react-query'
import axios from 'axios'

const defaultParams = {
  refetchOnWindowFocus: false,
  refetchOnmount: false,
  refetchOnReconnect: false,
  retry: false,
  staleTime: 1000 * 60 * 24,
  keepPreviousData: true,
}

const MOCK_LOCATIONS_DATA = {
  branches: [
    {
      id: 36,
      name: 'Queretaro - La Capilla',
    },
    {
      id: 38,
      name: 'CDMX Revolución',
    },
    {
      id: 40,
      name: 'EdoMex Santa Mónica',
    },
    {
      id: 43,
      name: 'CDMX San Jerónimo',
    },
    {
      id: 44,
      name: 'CDMX Universidad',
    },
  ],
  at_home: true,
}

// Fetcher para obtener TODAS las ubicaciones
const fetchAllInspectionLocations = async () => {
  const url = 'https://api.clikauto.com/api/inspection_locations'

  try {
    const req = await axios.get(url)
    if (Array.isArray(req.data)) {
      return {
        branches: req.data,
        at_home: true,
      }
    }
    return req.data
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('API call failed, returning mock data due to network/CORS error:', error)
    // 🟢 FALLBACK: Si la red falla (CORS), devolvemos la data estática normalizada
    return MOCK_LOCATIONS_DATA
  }
}

// Fetcher original (basado en zipcode) - Sin cambios
const fetchLocationsByZipcode = async (zipcode) => {
  const url = `${process.env.NEXT_PUBLIC_API_ROOT}/api/inspection_options/${zipcode}`
  const req = await axios.get(url)
  const data = await req.data
  return data
}

const fetchLocationByDateTime = async (params, isProd) => {
  const url = isProd
    ? `${process.env.NEXT_PUBLIC_API_ROOT}/api/inspection_options`
    : '/api/inpection_locations_date_time'
  const req = await axios.get(url, { params })
  const data = await req.data
  return data
}

const useLocations = () => {
  const useAllInspectionLocations = (enabled = true) => {
    return useQuery(
      'all_inspection_locations',
      fetchAllInspectionLocations,
      {
        enabled,
        ...defaultParams,
      },
    )
  }

  const useLocationsByZipcode = (zipcode, enabled) => {
    return useQuery(
      ['inpection_locations', zipcode],
      () => fetchLocationsByZipcode(zipcode),
      {
        enabled,
        ...defaultParams,
      },
    )
  }

  const useLocationsByDateTime = (params, isProd, enabled) => {
    return useQuery(
      ['inpection_locations_date_time', { params }],
      () => fetchLocationByDateTime(params, isProd),
      {
        enabled,
        ...defaultParams,
      },
    )
  }

  return {
    useLocationsByZipcode,
    useLocationsByDateTime,
    useAllInspectionLocations,
  }
}

export { useLocations }
